import { createComponent } from "@front/utils/alpine";
import Swiper, { Navigation, Autoplay, EffectFade, Thumbs } from "swiper";

const headerSlider = createComponent(() => ({
    setup () {
        const miniaturesSlider = new Swiper(this.$refs.miniatures, {
            modules: [
                Navigation,
            ],
            navigation: {
                prevEl: this.$refs.prev,
                nextEl: this.$refs.next,
            },
            slidesPerView: 3,
            speed: 750,
            direction: 'vertical',
            spaceBetween: 16,
            on: {
                init (swiper) {
                    swiper.wrapperEl.querySelectorAll('img').forEach(img =>
                        img.classList.add('lazy')
                    );
                },
            },
        });

        const fullSlider = new Swiper(this.$refs.full, {
            modules: [
                Autoplay,
                EffectFade,
                Thumbs
            ],
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            slidesPerView: 1,
            speed: 750,
            autoplay: {
                delay: 3000,
            },
            thumbs: {
                swiper: miniaturesSlider,
                slideThumbActiveClass: 'swiper-slide-thumb-active border-black',
            },
            on: {
                init (swiper) {
                    swiper.wrapperEl.querySelectorAll('img').forEach(img =>
                        img.classList.add('lazy')
                    );
                },
            },
        });
    }
}));

export default {
    headerSlider,
};
